import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { API_URL, setValToLS, getValFromLS } from "../helpers";

import Alert from "../components/Alert";

const CharityRegReturning = () => {
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const query = new URLSearchParams(useLocation().search);
	const history = useHistory();

	useEffect(() => {
		init();

		// eslint-disable-next-line
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/crReturningInit`);
		const params = {
			code: query.get("code") || "",
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push(json.redirect);
			} else {
				if (getValFromLS("crId")) {
					setValToLS("crId", "");
				}
				history.push("/registration/info");
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return <Alert data={alert} />;
};

export default CharityRegReturning;
